"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _da = _interopRequireDefault(require("./translations/da.json"));

var _de = _interopRequireDefault(require("./translations/de.json"));

var _el = _interopRequireDefault(require("./translations/el.json"));

var _en = _interopRequireDefault(require("./translations/en.json"));

var _es = _interopRequireDefault(require("./translations/es.json"));

var _fr = _interopRequireDefault(require("./translations/fr.json"));

var _nl = _interopRequireDefault(require("./translations/nl.json"));

var _nlBe = _interopRequireDefault(require("./translations/nl-be.json"));

var _nb = _interopRequireDefault(require("./translations/nb.json"));

var _sv = _interopRequireDefault(require("./translations/sv.json"));

var _fi = _interopRequireDefault(require("./translations/fi.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _reactIntl.defineMessages)(_en.default);
var _default = {
  da: _da.default,
  de: _de.default,
  el: _el.default,
  en: _en.default,
  es: _es.default,
  fr: _fr.default,
  nl: _nl.default,
  'nl-be': _nlBe.default,
  nb: _nb.default,
  sv: _sv.default,
  fi: _fi.default
};
exports.default = _default;